import { WeddingInvitation } from '../../types/invitation';
import { supabase } from './client';
import { transformDBInvitationToApp } from './transforms';
import { createLogger } from '../logger';

const invitationLog = createLogger('invitation');

export const publicInvitationService = {
  async getInvitationByCode(inviteCode: string): Promise<WeddingInvitation | null> {
    invitationLog.debug('查詢邀請碼（公開）', inviteCode);

    const { data, error } = await supabase
      .from('wedding_invitations')
      .select('*')
      .eq('invite_code', inviteCode)
      .eq('is_active', true)
      .single();

    if (error) {
      invitationLog.error('查詢邀請碼（公開）錯誤:', error);
      if (error.code === 'PGRST116') return null;
      throw error;
    }

    invitationLog.info('成功找到資料（公開）', data);
    return transformDBInvitationToApp(data);
  },
};
